const respostas = (state = [], action) => {
    switch (action.type) {
      case 'RESPOSTASRAPIDAS':
      return {
          type: "RESPOSTASRAPIDAS",
          respostas: action.respostas
        }
      default:
        return state
    }
  }
  
  export default respostas